import React from "react";
import "./arrowBtnHL.css";


/**
 * @param {*} props
 * @return {*}
 * @status no delete 
 * @description Arrow button custom react component
 */
const ArrowBtnHLPure = (props) => {
  const { textArrowBtn, onClickArrowBtn, primary, disabled } = props;

  return (
    <button
      disabled={disabled}
      className={
        primary === true
          ? "arrowBtnHLPure-primary-btn"
          : "arrowBtnHLPure-secondary-btn"
      }
      onClick={onClickArrowBtn}
    >
      {textArrowBtn}
      <span className="arrowBtnHLPure-arrow">{">"}</span>
    </button>
  );
};

export { ArrowBtnHLPure as default };
